import { Button, InlineText, Modal, ModalActions, ModalContent, ModalHeader, ModalLayout, Text } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DeleteUserConfirmModal = _ref => {
  let {
    isOpen,
    onRequestClose,
    onConfirm
  } = _ref;
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "DeleteUserConfirmModal",
    "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
    children: /*#__PURE__*/_jsxs(ModalLayout, {
      size: "s",
      "data-sentry-element": "ModalLayout",
      "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
      "data-sentry-element": "ModalLayout",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        "data-sentry-element": "ModalHeader",
        "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
        "data-sentry-element": "ModalHeader",
        children: "Delete user"
      }), /*#__PURE__*/_jsx(ModalContent, {
        "data-sentry-element": "ModalContent",
        "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
        "data-sentry-element": "ModalContent",
        children: /*#__PURE__*/_jsxs(Text, {
          "data-sentry-element": "Text",
          "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
          "data-sentry-element": "Text",
          children: ["Are you sure you want to delete this user? ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(InlineText, {
            fontWeight: 700,
            variant: "danger",
            "data-sentry-element": "InlineText",
            "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
            "data-sentry-element": "InlineText",
            children: "This action cannot be undone!"
          })]
        })
      }), /*#__PURE__*/_jsxs(ModalActions, {
        "data-sentry-element": "ModalActions",
        "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
        "data-sentry-element": "ModalActions",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onRequestClose,
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
          "data-sentry-element": "Button",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: () => {
            onConfirm();
            onRequestClose();
          },
          "data-sentry-element": "Button",
          "data-sentry-source-file": "DeleteUserConfirmModal.tsx",
          "data-sentry-element": "Button",
          children: "Confirm delete"
        })]
      })]
    })
  });
};